// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"393":"26b67f38","2208":"44b90b5d","2901":"44b90b5d","4410":"44b90b5d","7798":"44b90b5d"}[chunkId] + ".chunk.css";
};